import React, {useEffect, useState} from 'react';

import pictureLogo from '../../../images/logo.png';
import {useBreakpoint} from "../../../libs/breakpoint";
import Cookies from 'universal-cookie';
import backButton from "../../../libs/backButton";
import _ from "lodash";
import "./Disclaimer.scss";

import imgDisclaimerDesktop from "./images/banner-disclamer.png"
import imgDisclaimerMobile from "./images/banner-disclamer-mobile.png"

import imgArrowDown from "./images/go-down.png";
import imgPicto14 from "./images/pictos-14.png";
import img1 from "./images/images-1.png";
import img2 from "./images/images-2.png";
import img3 from "./images/images-3.png";

import pictoFlame from "./images/flame.svg";
import picto12 from "./images/pictos-12.svg"
import {SpinLoader} from "../../components/Loader";
import {apiUrl} from "../../../libs/api";


const cookies = new Cookies();

const Disclaimer = (props) => {
    const breakpoints = useBreakpoint();
    let source = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_source`) || "";
    let hasAcceptedDisclaimer = props.hasAcceptedDisclaimer;
    const [tool, setTool] = useState({
        loading : true,
        status : false,
        initialized : false
    });

    useEffect((props) => {
        const fetchData = async () => {
            try {
                if(!hasAcceptedDisclaimer) {
                    const result = await apiUrl.post(`/tools/istool`, {
                        userAgent: window.navigator.userAgent,
                        language: window.navigator.language,
                        platform: window.navigator.platform
                    }, {
                        timeout: 3000,
                    });

                    setTool({
                        loading: false,
                        status: _.get(result, 'data.status') || _.get(result, 'status') || false,
                        initialized: true
                    })
                }
                else{
                    setTool({
                        loading: false,
                        status: false,
                        initialized: true
                    })
                }
            }
            catch (e){

                setTool({
                    loading : false,
                    status : false,
                    initialized : true
                })
            }
        }
        fetchData();
    }, [hasAcceptedDisclaimer]);



    let isTool = tool.status;
    let isToolInitialized = tool.initialized;

    function godownContent(){
        let id = "content-down";
        if (document.getElementById(id)) {
            const element = document.getElementById(id);
            if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    function disclaim() {
        localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_fromdsiclaimer`, "1");
        cookies.set('DISCLAIMED', 'accepted',{expire:0});
        props.handleBlur();


/*
        let isChrome = RegExp(/Chrome\/[0-9.]+ (?:Mobile )?Safari\/[0-9.]+$|CriOS|Googlebot/).test(window.navigator.userAgent);
        //permet de verifier si on affiche ou non la popunder
        if(!isTool && isChrome){
            return;
        }

        // Pour les langues non-FR on coupe la popunder chrome
        let enterButton = document.querySelector('.enter-website');
        if ( isChrome && (document.querySelector('html.translated-ltr') || (enterButton && enterButton.innerText !== 'ENTRER')) ) {
            return;
        }
        */

        // Détection de Chrome (et non Chromium)
        let userAgent = window.navigator.userAgent;
        let isChrome = (userAgent.indexOf("Chrome") > -1 || userAgent.indexOf("CriOS") > -1) && userAgent.indexOf("Chromium") === -1;

        // Détection de la langue française
        let isFr = false;

// Vérifie d'abord navigator.languages
        if (Array.isArray(window.navigator.languages) && window.navigator.languages.length) {
            isFr = window.navigator.languages[0].substring(0, 2) === 'fr';
        }

// Ensuite, vérifie navigator.language si navigator.languages n'a pas déterminé isFr comme vrai
        if (!isFr && window.navigator.language) {
            isFr = window.navigator.language.substring(0, 2) === 'fr';
        }

// Finalement, vérifie navigator.userLanguage si les vérifications précédentes n'ont pas déterminé isFr comme vrai
        if (!isFr && window.navigator.userLanguage) {
            isFr = window.navigator.userLanguage.substring(0, 2) === 'fr';
        }

        // Détection de la page traduite par Chrome
        let chromeTranslated = isChrome && !!document.querySelector('html.translated-ltr');

        // Recherche du bouton "entrer" pour vérifier le texte
        let enterButton = document.querySelector('.enter-website');
        let isEnterTextCorrect = enterButton ? enterButton.innerText === 'ENTRER' : false;

        // Conditions pour ne pas afficher la popunder
        let bypassPunder = chromeTranslated || (isChrome && (!isFr || !isTool)) || !isEnterTextCorrect;

        // Logique pour la gestion de l'affichage de la popunder
        if (bypassPunder) {
            return ;
        }


        window.open( window.location.href, '_blank');
        backButton("popunder");
        let uriTool = breakpoints.md ? "https://tools.emstat.fr/voissa/pop-mobile.php" : "https://tools.emstat.fr/voissa/pop-desktop.php"
        if(!["", "voissa"].includes(source)){
            uriTool = `${uriTool}?adparameter2=${source}`
        }
        window.open(uriTool, "_self");
    }

    if(!props.hasAcceptedDisclaimer){
        backButton("popdisclaimer", {source});
    }
/*
    return props.hasAcceptedDisclaimer ? null : (
        <div id={"disclaimer"} >
            <div className={"container"}>
                <div className={"column website-infos"} onClick={(e) => e.stopPropagation()}>
                    <Title display={"display-1"} heading={"heading-2"}><img src={pictureLogo} alt={"logo Voissa"}/></Title>
                    <div className={"sub-title"}>
                        <div className={"pb-8"}><strong>Voissa</strong>, la première communauté <strong>exhib amateur
                            francophone</strong></div>
                        La référence <b>depuis 1999</b> avec plus d'un million de <u>photos sexy</u> et <u>vidéos porno
                        amateur</u>, des milliers de blogs et l'amour du sexe sans vulgarité.
                    </div>
                    <span className={"disclaimer-info"}>Pour accéder au contenu, je certifie être majeur.</span>
                    <div className={"btn-group"}>
                        <Button className={"enter-website"}
                                size={"medium"}
                                btnStyle={"primary-reverse"}
                                loading={!isToolInitialized}
                                onClick={() => isToolInitialized ? disclaim() : null}
                                icon={"18"}
                                iconSide={"right"}
                                content={"ENTRER"}/>

                    </div>
                </div>
            </div>
        </div>
    )*/


    return props.hasAcceptedDisclaimer ? null : (
        <div id="disclamer" className="disclamer" key={isToolInitialized}>
            <div className="disclamer-content">
                <div className="disclamer-content-banner">
                    <img className="banner-desktop" src={imgDisclaimerDesktop} alt="" />
                    <img className="banner-mobile" src={imgDisclaimerMobile} alt="" />
                </div>
                <div className="disclamer-content-info">

                    <div className="disclamer-content-info-logo">
                        <img src={pictureLogo} alt="" />
                        <p>Le plus bel espace de liberté</p>
                    </div>
                    <div className="disclamer-content-info-age">
                        <p>Le contenu de Voissa est <b>réservé aux adultes</b>.</p>
                        <p>Si vous n'avez pas encore 18 ans, l'accès est strictement interdit.</p>
                        {isToolInitialized ? (
                            <span className="disclamer-content-info-age-cta" onClick={() => disclaim()}>
                                <div className={"enter-website"}>ENTRER</div>
                                <span>(c'est gratuit !)</span>
                            </span>
                        ) : (
                            <span className="disclamer-content-info-age-cta" >
                                <SpinLoader />
                            </span>
                        )}

                        <span className="disclamer-content-info-age-down" onClick={()=> godownContent()} >Descendez pour en savoir plus sur Voissa</span>
                        <span className="disclamer-content-info-age-downicon" onClick={()=> godownContent()} ><img src={imgArrowDown} alt="" /></span>
                    </div>


                    <div className="disclamer-content-info-section" id={"content-down"}>
                        <div className="disclamer-content-info-section-img">
                            <div className="disclamer-content-info-section-img-picto">
                                <img src={picto12} alt="" />
                            </div>
                            <img className="disclamer-content-info-section-img-illu" src={img1} alt="" />
                        </div>
                        <div className="disclamer-content-info-section-content">
                            <h1>Vous êtes libre</h1>
                            <p>Depuis 1999 Voissa offre un lieu d’échange et de partage, un lieu pour créer en toute liberté.
                                C’est l'endroit parfait pour exprimer ses désirs, se révéler et faire des rencontres.
                                Notre communauté vibre au rythme de l'ouverture, de la bienveillance et du respect, valeurs clés qui nous animent au quotidien.
                            </p>
                        </div>
                    </div>

                    <div className="disclamer-content-info-section">
                        <div className="disclamer-content-info-section-content">
                            <h1>Le grand frisson (ou le petit)</h1>
                            <p>Rejoindre Voissa, c'est débuter une nouvelle aventure, choisir de s'épanouir pleinement.<br/>
                                Que vous soyez là pour partager ou juste pour explorer, Voissa est l'espace où vous pouvez vous exprimer librement.
                                À vous de jouer !
                            </p>
                        </div>
                        <div className="disclamer-content-info-section-img">
                            <div className="disclamer-content-info-section-img-picto">
                                <img src={pictoFlame} alt="" />
                            </div>
                            <img className="disclamer-content-info-section-img-illu" src={img2} alt="" />
                        </div>
                    </div>

                    <div className="disclamer-content-info-section">
                        <div className="disclamer-content-info-section-img">
                            <div className="disclamer-content-info-section-img-picto">
                                <img src={imgPicto14} alt="" style={{width :"43px", aspectRatio : 1, objectFit : "contain"}} />
                            </div>
                            <img className="disclamer-content-info-section-img-illu" src={img3} alt="" />
                        </div>
                        <div className="disclamer-content-info-section-content">
                            <h1>Un lieu « safe »</h1>
                            <p>Voissa est le jardin secret de milliers de membres, où l'anonymat et la sécurité sont toujours assurés.<br/>
                                Notre communauté et nos modérateurs travaillent ensemble pour maintenir une atmosphère accueillante et sûre pour tous.
                            </p>
                        </div>
                    </div>
                    <div className="disclamer-content-info-age no-box">
                        {isToolInitialized ? (
                            <span className="disclamer-content-info-age-cta" onClick={() => disclaim()}>
                                <div className={"enter-website"}>ENTRER</div>
                                <span>(c'est gratuit !)</span>
                            </span>
                        ) : (
                            <span className="disclamer-content-info-age-cta" >
                                <SpinLoader />
                            </span>
                        )}

                    </div>
                </div>
            </div>

        </div>
    )
};

export default Disclaimer;